export default __webpack_public_path__ + "static/media/topping_pinkalpaca.c17313dd.jpg";